import React from 'react';
import { Lightbulb } from 'lucide-react';
import KPICard from '../../components/shared/KPICard';
import AlarmDot from '../../components/shared/AlarmDot';
import StatusPill from '../../components/shared/StatusPill';
import SectionDivider from '../../components/shared/SectionDivider';
import DonutChart from '../../components/charts/DonutChart';
import { nationalAlarms, stateFaultDistribution } from '../../data/mockData';
import { AlarmSeverity } from '../../types';
import { relativeTime } from '../../utils/dateHelpers';

const gujaratAlarms = nationalAlarms.filter(a => a.state === 'Gujarat' || a.state === 'Rajasthan').slice(0, 4);

export default function StateAlarms() {
  return (
    <div className="p-6 space-y-6">
      <div className="flex gap-4">
        <KPICard title="Active Alarms" value="142" bgColor="bg-red-50" subtextColor="red" subtext="Gujarat state" />
        <KPICard title="Critical" value="18" bgColor="bg-red-50" subtextColor="red" subtext="Immediate action" />
        <KPICard title="Warning" value="74" bgColor="bg-orange-50" subtextColor="amber" subtext="Monitor closely" />
        <KPICard title="Resolved Today" value="31" subtextColor="green" subtext="MTTR: 3.8h avg" />
      </div>

      <div className="flex gap-4">
        <div className="flex-1 bg-white rounded-card border border-border shadow-card p-4">
          <SectionDivider title="Alarm Feed — Gujarat" subtitle="Active alarms" />
          <div className="space-y-3">
            {gujaratAlarms.map(alarm => (
              <div key={alarm.id} className={`flex gap-3 p-3 rounded-input border ${alarm.status === 'RESOLVED' ? 'border-border/40 opacity-70' : 'border-border'}`}>
                <AlarmDot severity={alarm.severity} />
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2">
                    <p className="text-xs font-semibold text-text-primary leading-tight">{alarm.description}</p>
                    <StatusPill
                      status={alarm.severity === AlarmSeverity.CRITICAL ? 'critical' : alarm.severity === AlarmSeverity.WARNING ? 'warning' : 'info'}
                    />
                  </div>
                  <p className="text-xs text-text-tertiary mt-1">
                    <span className="font-mono">{alarm.plantId}</span> · {alarm.state} · {relativeTime(alarm.timestamp)} · {alarm.duration}
                  </p>
                  {alarm.status === 'ACTIVE' && (
                    <button className="mt-2 flex items-center gap-1 text-xs text-accent hover:underline">
                      <Lightbulb size={11} /> Get advice
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="w-64 flex-shrink-0 bg-white rounded-card border border-border shadow-card p-4">
          <SectionDivider title="Fault Distribution" />
          <DonutChart key="state-alarms-donut" data={stateFaultDistribution} height={190} />
        </div>
      </div>
    </div>
  );
}
